import { combineReducers } from "redux";
import layout_reducer from "./layout_reducers";
import general_reducer from "./general_reducers";
import auth_reducer from "./auth_reducer";
import StoreStateModel from "../../components/Utils/Models/store";

import { persistReducer } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";

const layout_persistConfig = {
  key: "anavio_support_layout_config",
  storage: storageSession,
  whitelist: ["isOpenSideBar", "prefersDarkMode"], //here you will persist inside state of the reducer
};

const general_persistConfig = {
  key: "anavio_support_general_config",
  storage: storageSession,
  whitelist: ["portalId"],
};

const auth_persistConfig = {
  key: "anavio_support_auth_config",
  storage: storageSession,
  whitelist: [],
};

const createReducer = () =>
  combineReducers({
    layout: persistReducer(layout_persistConfig, layout_reducer),
    general: persistReducer(general_persistConfig, general_reducer),
    auth: persistReducer(auth_persistConfig, auth_reducer),
  } as StoreStateModel | any);
export default createReducer;
